var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.28 -606.47)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.79,621.4c-.28,0-.51-.23-.51-.51v-12.98c0-.28.23-.51.51-.51h7.68c.28,0,.51.23.51.51s-.23.51-.51.51h-7.17v11.96h12.14v-7.06c0-.28.23-.51.51-.51s.51.23.51.51v7.57c0,.28-.23.51-.51.51h-13.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 30.25,
    y: 610.63,
    width: 8.86,
    height: 2.77,
    transform: "translate(-422.6 203.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.21,608.07l-1.6-1.6c-.1-.1-.26-.1-.36,0l-1.06,1.06,1.96,1.96,1.06-1.06c.04-.05.07-.11.07-.18s-.03-.13-.07-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.27,614.59l-.94,2.44c-.04.09-.01.2.06.27.05.05.11.07.18.07.03,0,.06,0,.09-.02l2.44-.94-1.83-1.83Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFeedback);
export default __webpack_public_path__ + "static/media/sidebar_feedback.b64573a95ae05dc8d6fb9fba5f964f87.svg";
export { ForwardRef as ReactComponent };